<template>
  <div class="flex flex-col gap-12">
    <MoProductCard :card-data="moProductCardData" :show-indicators="true" />

    <div class="flex flex-col gap-4">
      <ActionCard
        class="bg-quaternary p-12 text-dark"
        :icon="IconQrcode"
        text="Carregar produto"
        :callback="handleClickLoadProduct"
      />

      <div class="flex">
        <VButton type="outline" title="Trocar OP" :callback="handleChangeMoClick" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAppStore } from '@/stores/app.store';
import { IconQrcode } from '@tabler/icons-vue';
import { computed, onMounted, watch } from 'vue';
import ActionCard from '../ActionCard/ActionCard.vue';
import VButton from '../Button/VButton.vue';
import MoProductCard from '../MoProductCard/MoProductCard.vue';
import { useFetchManufacturingOrder } from '../ScanOp/query';
import type { MoProducDataType } from './types';

interface Props  {
  handleClickLoadProduct: () => Promise<void>;
  handleChangeMoClick: () => Promise<void>;
  moProductCardData: MoProducDataType | null
}

defineProps<Props>();

const appStore = useAppStore();

const moCode = computed(() => appStore.currentManufacturingOrder?.orderNumber.toString() ?? '')

const { data, refetch: fetchManufacturingOrder } = useFetchManufacturingOrder(moCode);

watch(data, () => {
  if (data.value) {
    appStore.actions.setManufacturingOrder(data.value)
  }
})

onMounted(async () => {
  await fetchManufacturingOrder();
})
</script>